import { Link } from 'react-router-dom';
import { allArticles } from '@/pages/articles/data';

export default function ArticleCardsSection() {
  const displayArticles = allArticles.slice(1, 10);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full mb-3">
            Shopping Guides
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            pandabuyspreadsheet Category Guides
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            In-depth guides for every product category — learn how to find the best deals, verify quality, and shop smarter
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {displayArticles.map((article, i) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              className="group bg-background-50 border border-background-200/60 rounded-lg overflow-hidden hover:border-primary-300/50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-full h-40 md:h-44 overflow-hidden">
                <img
                  src={article.heroImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading={i < 3 ? 'eager' : 'lazy'}
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-2 whitespace-nowrap">
                  {article.category}
                </span>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 mb-3 line-clamp-2 leading-relaxed">
                  {article.description}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>{article.readTime}
                  </span>
                  <span className="flex items-center gap-1 text-primary-600 font-medium whitespace-nowrap">
                    Read Guide<i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/pandabuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            View Complete Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}